import { h, Component } from 'preact';
import { Text } from 'preact-i18n';
import { QRCodeSVG } from 'qrcode.react';

class WeaponCardShow extends Component {
    close = () => {
        const { appState } = this.props.stores;
        const { drawerLevel = 1 } = this.props;
        appState.toggleDrawer(false, drawerLevel);
    }

    render() {
        const { card = {} } = this.props;
        const title = `${card.brand || ''} ${card.model || ''}`.trim();
        return (
            <div class='w-100 d-flex flex-column align-items-center text-center' style='padding-top: 20px; padding-bottom: 100px;'>
                <h4 class='mb-1'>{title || <Text id='weaponCard.unnamed'>Weapon</Text>}</h4>
                {card.caliber && <div class='display-6 mb-3'>{card.caliber}</div>}
                {card.qrPayload ? (
                    <div class='bg-white p-3 rounded' style='max-width: 100%;'>
                        <QRCodeSVG value={card.qrPayload} size={300} style={{ maxWidth: '100%', height: 'auto' }} />
                    </div>
                ) : (
                    <div class='text-danger'><Text id='weaponCard.no-payload'>This card has no QR code text.</Text></div>
                )}
                <small class='text-body-secondary mt-3'>
                    <Text id='weaponCard.show-help'>Show this code to the seller when buying ammunition.</Text>
                </small>
                <button type='button' class='btn btn-outline-secondary rounded-pill mt-4' onClick={this.close}>
                    <Text id='weaponCard.close'>Close</Text>
                </button>
            </div>
        );
    }
}

export default WeaponCardShow;
